import { AuthenticationContext } from "@/app/context/authentication/authenticationContext"
import { FirebaseContext } from "@/app/context/firebase/firebaseContext"
import { FriendsContext } from "@/app/context/friends/friendsContext"
import { GlobalDataUserContext } from "@/app/context/global/globalDataUserContext"
import { getCreatureDetailsHelper } from "@/app/helpers/getCreatureDetailsHelper"
import { getUserFromFriendRequests } from "@/app/helpers/getUserFromFriendRequests"
import { Flex, Avatar, Badge,Button, Image, Modal, ModalBody, Text, Box, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, SimpleGrid, Alert, AlertIcon, VStack, Divider } from "@chakra-ui/react"
import { useTranslation } from "next-i18next"
import { useContext, useEffect, useMemo, useState } from "react"
import { BsBoxArrowInDown } from "react-icons/bs"
import { GiCupcake } from "react-icons/gi"
import { v4 } from "uuid"

type Props = {
    isOpen: boolean
    onClose: ()=>void
    originalCreature: any
}

export const SwitchCreature = ({isOpen, onClose, originalCreature}:Props) => {

    const { t } = useTranslation();
    
    const [creaturesInDouble, setCreaturesInDouble] = useState<any[]>([])
    const [selectedCreature, setSelectedCreature] = useState<any|null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const {
        cloudStorage,
        user
    }=useContext(AuthenticationContext)

    const {
        myCreatures,
        addTradeRequest,
        addFood
    }=useContext(GlobalDataUserContext)

    const {
        friendRequests,
        friendRequestWithUser
    }=useContext(FriendsContext)

    useEffect(()=>{
        if(isOpen && myCreatures && friendRequests){
            setSelectedCreature(null)
            setIsLoading(true)
            cloudStorage?.getCreaturesInDoubleFromFriends(friendRequests,myCreatures,originalCreature.id).then((data:any)=>{
                if ( process.env.NODE_ENV==="development" ) {
                    console.log("result creatureInDouble",friendRequests, data)
                }
                setCreaturesInDouble(data)
                setIsLoading(false)
            })
        }
    },[isOpen])

    const onConfirmSwitch = () => {
        if(selectedCreature){
            addTradeRequest({
                id: v4(),
                senderCreatureId: originalCreature.id,
                senderOriginalCreatureId: originalCreature.creatureId,
                receiverCreatureId: selectedCreature.creatureId,
                receiverOriginalCreatureId: selectedCreature.id,
                senderId: user?.uid as string,
                receiverId: selectedCreature.ownerId,
                status: "pending",
                timestamp: Date.now(),
                isSynchronized: false
            })
            onClose()
        }
    }

    const creatureDetails = useMemo(() => {
        const combinedCreatures = [...(creaturesInDouble || []), ...(myCreatures || [])];
    
        return combinedCreatures?.reduce((acc:any, creature) => {
        acc[creature.creatureId] = getCreatureDetailsHelper(creature.creatureId);
        return acc;
        }, {});
    }, [creaturesInDouble, myCreatures]);
    

    const switchForFood= ()=> {
        addFood(creatureDetails[originalCreature?.id]?.level)
        cloudStorage?.deleteCreaturesFromCloud(originalCreature.creatureId).then(()=>{
            onClose()
        })
    }

    return (
        <Modal isCentered isOpen={isOpen} onClose={onClose} size="xs">
            <ModalOverlay />
            <ModalContent maxH="80vh" overflow={"hidden"}>
                <ModalHeader px={4} pb={0}>{t("tradeRequest.modalTitle")}</ModalHeader>
                <ModalCloseButton />
                <ModalBody px={4} overflow="auto">
                    <Text>{t("tradeRequest.modalExplanation")}</Text>
                    {creaturesInDouble && <SimpleGrid overflowY="auto" zIndex={2} columns={3} spacing={3} w="full" p={0} pt={4}>                        
                    {creaturesInDouble.map((creature:any)=>{
                        return <Flex key={creature.id} flexDirection="column" filter={creature.id==selectedCreature?.id?"grayscale(0)":"grayscale(1)" } opacity={creature.id==selectedCreature?.id?1:0.4} onClick={()=>setSelectedCreature(selectedCreature!==creature?creature:null)}>
                            <Flex position="relative" h="150px" borderRadius={10} overflow="hidden">
                                <Image borderRadius={10} src={creatureDetails[creature.creatureId]?.url} alt="monster"/>
                                <Flex 
                                    position="absolute"
                                    bottom={3}
                                    w="full"
                                    justifyContent={"center"}
                                >
                                    <Text 
                                        background={creatureDetails[creature.creatureId]?.type=="LEGENDARY"? "#eba628":(creatureDetails[creature.creatureId]?.type=="AQUATIC"? "#3797d1":"#00000099")} 
                                        px={3} 
                                        py={1} 
                                        fontSize={"0.7em"} 
                                        borderRadius={10} 
                                        fontWeight="bold" 
                                        color={creatureDetails[creature.creatureId]?.type=="LEGENDARY"?"white":"white"}
                                        lineHeight={"normal"}
                                        display={"flex"}
                                        alignItems={"center"}
                                    >
                                        {creatureDetails[creature.creatureId]?.name.toUpperCase()}
                                        {creatureDetails[creature.creatureId]?.level && <Badge minW="21px" textAlign="center" ml={2} p={1} borderRadius={"10"}>{creatureDetails[creature.creatureId]?.level}</Badge>}
                                    </Text>   
                                </Flex>
                            </Flex>
                            <Flex direction="row" alignItems={"center"}>
                                <Avatar size="2xs" src={getUserFromFriendRequests(friendRequestWithUser,creature.ownerId)?.photoUrl}  icon={undefined} name={getUserFromFriendRequests(friendRequestWithUser,creature.ownerId)?.name} />
                                <Text pl={1} textOverflow={"ellipsis"}
                                    whiteSpace={"nowrap"}
                                    overflow={"hidden"}>{getUserFromFriendRequests(friendRequestWithUser,creature.ownerId)?.name}</Text>
                            </Flex>
                        </Flex>
                    })}
                    </SimpleGrid>}

                    {isLoading && <Flex w="full" h="full" justifyContent="center" alignItems="center">
                            <Text>{t("tradeRequest.loading")}</Text>
                        </Flex>}
                    {(!creaturesInDouble || !creaturesInDouble.length ) && !isLoading && friendRequests && friendRequests.length &&  
                        <Alert status='error'>
                            <AlertIcon />                        
                            <Text>{t("tradeRequest.No creature available")}</Text></Alert>}
                    {(!creaturesInDouble || !creaturesInDouble.length ) && (!friendRequests || !friendRequests.length) && 
                        <Alert status='error'>
                            <AlertIcon />                        
                            <Text>{t("tradeRequest.No friend available")}</Text></Alert>
                            }
                </ModalBody>
                <ModalFooter py={2} px={3}>
                    <VStack w="full" spacing={0}>
                        <Box w="full" textAlign={"end"}>
                            <Button size="sm" variant="ghost" onClick={onClose} pr={4}>{t("tradeRequest.cancel")}</Button>
                            <Button size="sm" disabled={!selectedCreature} colorScheme={selectedCreature?"orange":"gray"} mr={3} onClick={()=>{selectedCreature && onConfirmSwitch()}}>
                                {t("tradeRequest.echanger")}
                            </Button>     
                        </Box>   
                        <Divider pt={5} borderColor="lightGrey"/>   
                        <Text py={2} fontSize="sm"> {t("tradeRequest.exchangeCupcakes")}</Text>
                        <Box w="full" textAlign={"end"}>
                            <Button colorScheme={"linkedin"} mr={0} pr={2} onClick={()=>{switchForFood()}}>
                                <Text textAlign={"start"}>{t("tradeRequest.echanger")} </Text>
                                <Box
                                    display={"flex"}
                                    background={"transparent!important"}
                                    p={1}
                                    pr={3}
                                    m={0}
                                    color="white"
                                    fontSize={"1.5em"}
                                    position="relative"
                                >
                                        <GiCupcake />
                                        <Badge position="absolute" bottom={0} right={0} bg="white" color='black'>{creatureDetails[originalCreature?.id]?.level}</Badge>
                                </Box> 
                            </Button>     
                        </Box>   
                    </VStack>         
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}